var map = {
	"./4341.mp3": [
		905,
		905
	],
	"./4341b.mp3": [
		6457,
		457
	],
	"./6384.mp3": [
		3582,
		582
	],
	"./6384b.mp3": [
		6240,
		240
	],
	"./b.mp3": [
		2955,
		955
	],
	"./f.mp3": [
		1887,
		887
	],
	"./m.mp3": [
		5648,
		648
	],
	"./p.mp3": [
		5641,
		641
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2409;
module.exports = webpackAsyncContext;